import React from "react";
import { reduxForm, Field } from "redux-form";
import { Glyphicon } from "react-bootstrap";

import Textarea from "../../../../components/common/textarea/Textarea";
import Button from "../../../../components/common/button/Button";
import FileInput from "../../../../components/common/fileInput/FileInput";
import { maxFileSize } from "../../../../utils/forms/validators";
import styles from "./SendForm.scss";

import { Mixpanel } from "../../../../actions/mixpanel.actions";
import { PROJECT_SEND_MESSAGE_FORM } from "../../../../actions/project.actions";

export const fileValidation = file => maxFileSize(file, 4);

class SendForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filename: null
    };

    this.onSelect = this.onSelect.bind(this);
    this.attachFile = this.attachFile.bind(this);
    this.removeFile = this.removeFile.bind(this);
  }

  onSelect = value => {
    this.setState({
      filename: value
    });
  };

  attachFile() {
    Mixpanel.track("Project - Messages - Upload Attachment");

    const fileInput = document.getElementById("message-attachment");
    fileInput.click();
  }

  removeFile() {
    const fileInput = document.getElementById("message-attachment");
    fileInput.value = "";

    this.onSelect(null);
  }

  renderAttachment() {
    const component = (
      <div className={styles.messageAttachment}>
        <div className={styles.messageAttachmentContent}>
          <div className={styles.messageAttachmentContentText}>
            Attachment: {this.state.filename}
          </div>
          <div
            className={styles.messageAttachmentContentButton}
            onClick={this.removeFile}
          >
            <Glyphicon glyph="remove" />
          </div>
        </div>
      </div>
    );

    return this.state.filename ? component : null;
  }

  render() {
    const { handleSubmit, invalid, submitting, pristine } = this.props;

    return (
      <form className={styles.sendForm} onSubmit={handleSubmit}>
        <div className={styles.doubleDivider} />

        <div className={styles.sendFormContent}>
          <div className={styles.form}>
            <div className={styles.input}>
              <div>
                <Field
                  name="message"
                  type="textarea"
                  placeholder="Write a message"
                  component={Textarea}
                  disableCounter={true}
                />

                <Glyphicon
                  className={styles.attachmentIcon}
                  glyph="paperclip"
                  onClick={this.attachFile}
                />
              </div>
            </div>

            {this.renderAttachment()}

            <div className={styles.inputFile}>
              <Field
                component={FileInput}
                name="message-attachment"
                accept=".doc,.docx,.pdf"
                validate={this.state.filename ? fileValidation : null}
                onSelect={this.onSelect}
              />
            </div>
          </div>

          <div className={styles.button}>
            <Button
              type="submit"
              isDisabled={invalid || submitting || pristine}
              label="SEND"
              onClick={() => this.setState({ filename: null })}
            />
          </div>
        </div>
      </form>
    );
  }
}

SendForm = reduxForm({
  form: PROJECT_SEND_MESSAGE_FORM
})(SendForm);

export default SendForm;



// WEBPACK FOOTER //
// ./src/routes/common/messages/SendForm/SendForm.js